import type { CartUpsellStats } from '../../../types/analyticstypes';
import { formatPrice, formatRate } from '../../../utils/analytics/format';

interface Props {
  data?: CartUpsellStats;
}

export default function CartUpsellsCard({ data }: Props) {
  if (!data) return null;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-5 shadow-sm">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Cart Triggered Upsells</h3>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-gray-50 rounded p-3">
          <div className="text-xs text-gray-500 uppercase tracking-wide font-semibold mb-1">Times Offered</div>
          <div className="text-2xl font-bold text-gray-800">{data.impressions}</div>
        </div>
        <div className="bg-gray-50 rounded p-3">
          <div className="text-xs text-gray-500 uppercase tracking-wide font-semibold mb-1">Accepted</div>
          <div className="text-2xl font-bold text-gray-800">{data.accepts}</div>
        </div>
        <div className="bg-gray-50 rounded p-3">
          <div className="text-xs text-gray-500 uppercase tracking-wide font-semibold mb-1">Take Rate</div>
          <div className="text-2xl font-bold text-fuchsia-600">{formatRate(data.takeRate)}</div>
          <div className="text-[11px] text-gray-400 mt-1 leading-tight">Accepted ÷ Offered</div>
        </div>
        <div className="bg-gray-50 rounded p-3">
          <div className="text-xs text-gray-500 uppercase tracking-wide font-semibold mb-1">Revenue</div>
          <div className="text-2xl font-bold text-emerald-600">{formatPrice(data.revenue)}</div>
        </div>
      </div>

      <h4 className="text-sm font-semibold text-gray-700 mb-3">Top Items Taken</h4>
      {data.topItems.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm text-gray-600">
            <thead className="text-xs text-gray-400 uppercase bg-gray-50/50">
              <tr>
                <th className="px-3 py-2 font-medium">Item Name</th>
                <th className="px-3 py-2 font-medium text-right">Count</th>
                <th className="px-3 py-2 font-medium text-right">Revenue</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data.topItems.map((item, idx) => (
                <tr key={idx} className="hover:bg-gray-50/50 transition-colors">
                  <td className="px-3 py-2 text-gray-800 font-medium">{item.name}</td>
                  <td className="px-3 py-2 text-right">{item.count}</td>
                  <td className="px-3 py-2 text-right text-emerald-600 font-medium">{formatPrice(item.revenue)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-sm text-gray-400 italic">No items accepted yet.</div>
      )}
    </div>
  );
}
